import { render, staticRenderFns } from "./OnlCgformHeadModal.vue?vue&type=template&id=8b90d246&scoped=true&"
import script from "./OnlCgformHeadModal.vue?vue&type=script&lang=js&"
export * from "./OnlCgformHeadModal.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformHeadModal.vue?vue&type=style&index=0&id=8b90d246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b90d246",
  null
  
)

export default component.exports